import styled from "styled-components";

export const SwiperWrapper = styled.div`
  width: 100%;
  height: 100%;
  .slick-list {
    padding: unset !important;
  }
`;
